<button
  type="button"
  [class]="`btn btn-circle btn-tertiary ${buttonClass()}`"
  [disabled]="disabled() || null"
  [attr.aria-label]="ariaLabel()"
  (click)="onClick()"
>
  <si-icon class="icon flip-rtl" [icon]="icon()" />
</button>
